import React from 'react';
import { FeaturedContentContainer } from './styles';
import Text from 'components/Core/Text';
import Button from 'components/Core/Button';
import { ArrowRightIcon } from 'components/Brand/Icons';
import { WebsiteImage } from 'components/TitleDescription';
import { Col, Row } from 'antd';
import getBreakpointView from 'utils/getBreakpointView';
import Cards from 'components/Core/Cards';
import {
  getKicker,
  getCtaLink,
  getCtaLabel,
  getImageSrc,
  getImageAlt,
  getTitle,
} from 'components/Page/Toolbox/utils';

const FeaturedContent = props => {
  const { feature } = props || {};
  const isMobile = getBreakpointView(['xs', 'sm']);
  const src = getImageSrc(feature);
  const alt = getImageAlt(feature);
  const kicker = getKicker(feature);
  const title = getTitle(feature);
  const ctaLink = getCtaLink(feature);
  const ctaLabel = getCtaLabel(feature);

  return (
    <FeaturedContentContainer>
      {!isMobile ? (
        <Row>
          <Col md={10} lg={10}>
            <FeaturedCopy kicker={kicker} title={title} ctaLabel={ctaLabel} ctaLink={ctaLink} />
          </Col>
          <Col md={14} lg={14}>
            <WebsiteImage src={src} alt={alt} className="featured-content--image" />
          </Col>
        </Row>
      ) : (
        <Cards
          type={'Image'}
          bodyType={'simple'}
          category={<HeadingKicker kicker={kicker} />}
          coverImage={src}
          title={title}
          cta={<CTA link={ctaLink} label={ctaLabel} />}
          ctaLink={ctaLink}
        />
      )}
    </FeaturedContentContainer>
  );
};

const FeaturedCopy = ({ kicker, title, ctaLink, ctaLabel }) => (
  <Row align="middle" className="featured-content--copy-container">
    <div className="featured-content--copy">
      <HeadingKicker kicker={kicker} />
      <Text className="featured-content--title" size="31px" type="h4">
        {title}
      </Text>
      <CTA link={ctaLink} label={ctaLabel} />
    </div>
  </Row>
);

const HeadingKicker = ({ kicker }) => (
  <Text className="featured-content--headingkicker" size="16px" type="p" color="#009DE6">
    {kicker}
  </Text>
);

const CTA = ({ link, label }) => (
  <Button className="featured-content--cta" type="secondary" to={link} height="39px">
    {label}
    <ArrowRightIcon />
  </Button>
);

export default FeaturedContent;
